import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorProperties } from '../../API/identityAPIProperties';
import API from '../../API/Main/API';
import { resetState } from '../../resetState';
import { InsuranceProperties } from '../../API/ClientAPIHelpers/insuranceAuthorizationProperties';

export const getUserInsurances = createAsyncThunk('/user/user/insurances', async (id: string, thunkAPI) => {
	const response = await API.UserAPI.Insurance.getUserInsurances(id);

	if (response.error) {
		return thunkAPI.rejectWithValue(response.error);
	}

	return response as InsuranceProperties[];
});

interface InsuranceInitialStateProperties {
	error: ErrorProperties;
	insurances: InsuranceProperties[];

	loading: boolean;
	userInsurances: InsuranceProperties[];
}

const initialInsuranceState: InsuranceInitialStateProperties = {
	loading: false,
	error: {
		status: 0,
		title: '',
	},
	userInsurances: [],
	insurances: [],
};

const insuranceSlice = createSlice({
	name: 'insurance',
	initialState: initialInsuranceState,
	reducers: {},
	extraReducers: (builder) => {
		// getUserInsurances
		builder.addCase(getUserInsurances.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(getUserInsurances.fulfilled, (state, action) => {
			state.loading = false;
			state.userInsurances = action.payload;
		});
		builder.addCase(getUserInsurances.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload as ErrorProperties;
		});

		// reset state
		builder.addCase(resetState, () => initialInsuranceState);
	},
});

export default insuranceSlice.reducer;
